import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import { opacityVariants } from './framer-variants';

export const OpacityAnimation = (props: PropsWithChildren) => {
  return (
    <motion.div
      // Start at the final state. Fading in from 0 hides the whole page content
      // for a moment right after the loading animation, which reads as a flicker.
      initial={false}
      animate="in"
      exit="out"
      variants={opacityVariants}
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      data-testid="opacity-animation"
    >
      {props.children}
    </motion.div>
  );
};
